module.exports = __webpack_public_path__ + "img/cover-girl.eb7b4e6d.png";